{
  "$schema": "https://mux.run/theme.json",
  "name": "Ayu",
  "id": "ayu",
  "light": {
    "palette": {
      "neutral": "#fdfaf4",
      "ink": "#4f5964",
      "primary": "#4aa8c8",
      "accent": "#ef7d71",
      "success": "#5fb978",
      "warning": "#ea9f41",
      "error": "#e6656a",
      "info": "#2f9bce",
      "diffAdd": "#b1d780",
      "diffDelete": "#e6656a"
    },
    "overrides": {
      "syntax-comment": "#6e7681",
      "syntax-keyword": "#c76a1a",
      "syntax-string": "#6f8f00",
      "syntax-primitive": "#b87500",
      "syntax-property": "#2f86b7",
      "syntax-type": "#227fc0",
      "syntax-constant": "#a37acc"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#0f1419",
      "ink": "#d6dae0",
      "primary": "#3fb7e3",
      "accent": "#f2856f",
      "success": "#78d05c",
      "warning": "#e4a75c",
      "error": "#f58572",
      "info": "#66c6f1",
      "diffAdd": "#59c57c",
      "diffDelete": "#f58572"
    },
    "overrides": {
      "syntax-comment": "#5a6673",
      "syntax-keyword": "#ff8f40",
      "syntax-string": "#aad94c",
      "syntax-primitive": "#ffb454",
      "syntax-property": "#39bae6",
      "syntax-type": "#59c2ff",
      "syntax-constant": "#d2a6ff"
    }
  }
}
